import { useState } from 'react';
import ProjectTile from './ProjectTile.jsx';

const COLUMN_LABELS = { now: 'Now', next: 'Next', later: 'Later', done: 'Done' };

export default function ProjectColumn({
  columnKey,
  projects,
  draggingId,
  onTileSelect,
  onTileColumnChange,
  onTileDragStart,
  onTileDragEnd,
  onDropToColumn,
}) {
  const [isOver, setIsOver] = useState(false);

  function handleDragOver(e) {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    if (!isOver) setIsOver(true);
  }

  function handleDragLeave(e) {
    // Only un-highlight when leaving the column wrapper, not children.
    if (e.currentTarget.contains(e.relatedTarget)) return;
    setIsOver(false);
  }

  function handleDrop(e) {
    e.preventDefault();
    setIsOver(false);
    const id = e.dataTransfer.getData('text/plain');
    if (id) onDropToColumn(id, columnKey);
  }

  return (
    <div
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      className={`bg-bg-input/30 border rounded p-3 transition ${
        isOver ? 'border-accent-blue bg-accent-blue/5' : 'border-border-base'
      }`}
    >
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-xs uppercase tracking-wider text-text-secondary font-semibold">
          {COLUMN_LABELS[columnKey]}
        </h3>
        <span className="text-[10px] px-1.5 py-0.5 bg-bg-card border border-border-base rounded text-text-muted">
          {projects.length}
        </span>
      </div>

      {projects.length === 0 ? (
        <div className="text-center text-xs text-text-muted py-6">
          Drop a project here
        </div>
      ) : (
        <div className="space-y-2">
          {projects.map((p) => (
            <ProjectTile
              key={p.id}
              project={p}
              isDragging={draggingId === p.id}
              onSelect={onTileSelect}
              onColumnChange={onTileColumnChange}
              onDragStart={onTileDragStart}
              onDragEnd={onTileDragEnd}
            />
          ))}
        </div>
      )}
    </div>
  );
}
